import { Link, useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { RightArrowIcon } from '../icon/icon';
import { motion } from 'framer-motion';
import { user } from '../../utils/menu';
import { Button } from '../items/Button';
import { useEffect, useState } from 'react';
import { fetchDriverMypage } from '../../api/mypage';
import { useSetRecoilState } from 'recoil';
import { authState } from '../../atoms/authState';

export const Navigation = ({ setIsOpen }: any) => {
  const [userInfo, setUserInfo] = useState<{
    vehicle: string | null;
  } | null>(null); // Add userInfo state
  const setAuth = useSetRecoilState(authState); // Recoil 상태 업데이트 함수
  const history = useHistory(); // useHistory 훅을 사용하여 페이지 이동 처리

  useEffect(() => {
    // Fetch user info when the component mounts
    const fetchUserInfo = async () => {
      try {
        const data = await fetchDriverMypage(); // Fetch user info from API
        setUserInfo({
          vehicle: data.vehicle,
        }); // Set user info state
      } catch (error) {
        console.error('Failed to fetch user info', error);
      }
    };

    fetchUserInfo();
  }, []);

  const handleLinkClick = () => {
    setIsOpen(false);
  };

  const handleLogout = () => {
    // 로그아웃 로직
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('expire');
    localStorage.removeItem('authState');

    // Recoil 상태 초기화
    setAuth({
      isAuthenticated: false,
      userType: '',
    });

    // 홈 화면으로 리다이렉트
    history.push('/');
  };

  return (
    <Container>
      <div className="user-info">
        <p>안녕하세요.</p>
        <Link
          onClick={handleLinkClick}
          to={{
            pathname: '/mypage',
          }}
        >
          {userInfo ? `${userInfo.vehicle} 기사님` : '로드 중...'}{' '}
          {/* userInfo가 null이 아닌 경우만 접근 */}
          <RightArrowIcon />
        </Link>
      </div>
      <Menus>
        {user.map((item, index) => (
          <li key={index}>
            <Link to={item.path} onClick={handleLinkClick}>
              <div className="menu-name">
                <div className="icon-box">{<item.icon />}</div>
                {item.title}
              </div>
              <div className="icon-box">
                <RightArrowIcon />
              </div>
            </Link>
          </li>
        ))}
      </Menus>
      <div className="logout-box">
        <Button title="로그아웃" onClick={handleLogout} />
      </div>
    </Container>
  );
};

// style
const Container = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  //background-color: ${(props) => props.theme.textWhiteColor};
  z-index: 1;
  .user-info {
    background-color: ${(props) => props.theme.btnBlueColor};
    padding: 8.4rem 1.4rem 3rem;
    margin-bottom: 1.3rem;
    * {
      color: ${(props) => props.theme.textWhiteColor};
    }
    p {
      font-size: 2.4rem;
      font-weight: 500;
      margin-bottom: 0.8rem;
    }
    a {
      display: flex;
      align-items: center;
      font-size: 2.4rem;
      font-weight: 700;
      gap: 0.8rem;
      text-decoration: underline;
    }
  }
  .logout-box {
    position: absolute;
    left: 0;
    bottom: 6.2rem;
    padding: 0 1.4rem;
    width: 100%;
    button {
      background-color: ${(props) => props.theme.logoutBtnBgColor};
      font-size: 1.4rem;
      font-weight: 400;
      color: ${(props) => props.theme.gray900};
      padding: 0.8rem;
      border-radius: 0.8rem;
    }
  }
`;

const Menus = styled(motion.ul)`
  li {
    border-bottom: 1px solid ${(props) => props.theme.f5f5f5};
    a {
      padding: 0.8rem 1.4rem 0.72rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 1.6rem;
      font-weight: 500;
      .menu-name {
        display: flex;
        align-items: center;
        gap: 1.6rem;
        .icon-box {
          display: flex;
          width: 3.681rem;
          height: 3.681rem;
          align-items: center;
          justify-content: center;
          background-color: ${(props) => props.theme.navIconBgColor};
          border-radius: 1.2rem;
        }
      }
      > .icon-box {
        svg {
          path {
            fill: ${(props) => props.theme.loginHrColor};
            fill-opacity: 1;
          }
        }
      }
    }
  }
`;
